<template>
  <div class="price-per-person">
    <PopupHeader title="Cena za osobę" icon="man" @close="close" />
    <RadioList ref="list" class="price-per-person__body" :options="options" v-model="selected" @input="$emit('input', selected)" />
    <PopupFooter @select="$emit('input', selected)" @clear="$refs.list.clear()" @selectAll="$refs.list.selectAll()" />
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import PopupFooter from './PopupFooter.vue'
import PopupHeader from './PopupHeader.vue'

import AutoCloseMixin from '@/components/AutoCloseMixin'
import BodyFreezerMixin from '@/components/BodyFreezerMixin'
import RadioList from '@/components/RadioList.vue'

@Component({
  mixins: [
    AutoCloseMixin,
    BodyFreezerMixin,
  ],
  components: {
    RadioList,
    PopupHeader,
    PopupFooter,
  },
  props: {
    value: {
      type: String,
      required: true,
      nullable: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
})
export default class PricePerPerson extends Vue {
  selected = this.value

  created () {
    this.freezeBody()
  }

  destroyed () {
    this.unfreezBody()
  }
}
</script>

<style lang="scss">
@import '../mobile-popup.scss';

.price-per-person {
  @include mobile-popup(white, #005ca9);

  &__body {
    @include mobile-popup__body(black, white, true);

    .radiolist-item {
      margin-bottom: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search/fields/PricePerPersonPopup.vue